import { createRouter, createWebHistory } from 'vue-router';


const routes = [
    {
        path: "/",
        name: "Cabinet",
        component: () => import("@/components/CabinetCustomer.vue")
    },
    {
        path: "/confirm",
        name: "Confirm",
        component: () => import("@/components/ConfirmEmail.vue")
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
//   history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
